import React from 'react';

// Definiere die Props, um entweder eine React-Komponente oder einen String zu akzeptieren
interface ImageComponentProps {
    src: React.ElementType | string;
    alt?: string;
}

const ImageComponent: React.FC<ImageComponentProps> = ({ src, alt }) => {
    // Prüfe, ob src ein React.ElementType (für SVG) oder ein String (für PNG) ist
    if (typeof src === 'string') {
        // Behandle src als Bildpfad, wenn es ein String ist
        return <img src={src} alt={alt || 'image'} />;
    } else {
        // Behandle src als React-Komponente (SVG), wenn es kein String ist
        const SvgComponent = src;
        return <SvgComponent aria-label={alt} />;
    }
};

export default ImageComponent;
